const selectWorkflow = state => {
  return {
    ...state.workflow
  };
};

const selectMemberFek = state => {
  return {
    ...state.workflow.memberFek
  };
};

const selectMemberIban = state => {
  return {
    ...state.workflow.memberIban
  };
};

export { selectWorkflow, selectMemberFek, selectMemberIban };

